<template>
  <div class="buy-vip-container">
    <el-card class="notice-card">
      <template #header>
        <div class="card-header">
          <span class="header-title">会员系统升级通知</span>
        </div>
      </template>
      <div class="content">
        <el-result
          icon="info"
          title="计费模式全新升级"
          sub-title="为了提供更灵活、经济的服务体验，会员体系已全面升级为【积分按量计费】模式。积分无过期限制，用多少扣多少，彻底告别月卡/年卡的闲置浪费，让每一分投入都物超所值，链接如下:-)"
        >
          <template #extra>
            <el-button type="primary" size="large" @click="goToUserCenter" class="flash-button">前往个人中心充值</el-button>
          </template>
        </el-result>

        <el-divider content-position="center">经典会员回顾 (已升级为积分制)</el-divider>

        <!-- 恢复的卡片展示区域 -->
        <el-row :gutter="20" class="cards-showcase">
          <el-col :span="6" v-for="card in cards" :key="card.type">
            <el-card :class="['vip-card']" :style="getCardStyle(card)">
            </el-card>
            <div class="card-info">
              <p>{{ card.type }}</p>
              <p class="upgrade-tag">已升级</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "BuyVip",
  data() {
    return {
      cards: [
        {
          type: "一个月会员",
          color: "#76A6C2",
          image: "https://azlinux.oss-cn-zhangjiakou.aliyuncs.com/sre/bg/monthly-card.png",
        },
        {
          type: "季度会员",
          color: "#FEF1B8",
          image: "https://azlinux.oss-cn-zhangjiakou.aliyuncs.com/sre/bg/quarterly-card.png",
        },
        {
          type: "半年会员",
          color: "#D9E4B5",
          image: "https://azlinux.oss-cn-zhangjiakou.aliyuncs.com/sre/bg/half-year-card.png",
        },
        {
          type: "年度会员",
          color: "#992023",
          image: "https://azlinux.oss-cn-zhangjiakou.aliyuncs.com/sre/bg/annual-card.png",
        },
      ],
    };
  },
  methods: {
    goToUserCenter() {
      this.$router.push('/user-center');
    },
    getCardStyle(card) {
      return {
        backgroundColor: card.color,
        backgroundImage: `url(${card.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
  }
};
</script>

<style scoped>
.buy-vip-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background-color: #f0f2f5;
  padding: 20px;
}

.notice-card {
  width: 100%;
  max-width: 1000px; /* 增加宽度以容纳4张卡片 */
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  text-align: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content {
  padding: 20px 0;
}

/* Customize el-result styles if needed */
:deep(.el-result__title) {
  margin-top: 20px;
  font-size: 24px;
}

:deep(.el-result__subtitle) {
  margin-top: 10px;
  font-size: 16px;
  line-height: 1.6;
  text-align: justify;
  padding: 0 20px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* 卡片样式 */
.cards-showcase {
  margin-top: 30px;
  padding: 0 20px;
}

.vip-card {
  height: 140px; /* 稍微调小一点以适应布局 */
  border-radius: 8px;
  border: none;
  transition: transform 0.3s ease;
  cursor: default;
}

.vip-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
}

.card-info {
  text-align: center;
  margin-top: 10px;
}

.card-info p {
  margin: 5px 0;
  color: #606266;
  font-weight: 500;
}

.upgrade-tag {
  color: #909399 !important;
  font-size: 12px;
  background: #f4f4f5;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
}

@keyframes pulse-flash {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

.flash-button {
  animation: pulse-flash 2s infinite;
  font-weight: bold;
}
</style>
